import settings from '@/settings'

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/cadastrar/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let listCombustiveis = (headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let atualizarCombustivel = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/update/?id_combustivel=${id}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let removerCombustivel = (id, headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/remover/?id_combustivel=${id}`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  insert,
  listCombustiveis,
  atualizarCombustivel,
  removerCombustivel
}
